import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IOSSwitch } from '../IOSSwitch';

interface RouterLinkdownRelayEditProps {
  onSubmit: () => void;
  cpeId: string;
  linkDownRelay: boolean;
  privateLine?: boolean;
}

export const RouterLinkdownRelayEdit = ({ onSubmit, cpeId, linkDownRelay, privateLine }: RouterLinkdownRelayEditProps) => {
  const api = useApi();
  const [newLinkDownRelay, setNewLinkDownRelay] = useState<boolean>(linkDownRelay);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewLinkDownRelay(e.target.checked);
    setDisableSubmit(e.target.checked === linkDownRelay);
  };

  const editLinkDownRelay = useMutation(api.editLinkRelayApiV1EditLinkRelayPost, {
    onSuccess() {
      toast.success(`${newLinkDownRelay ? 'Enabled' : 'Disabled'} link relay successfully.`);
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    }
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    editLinkDownRelay.mutate({
      cpe_id: cpeId,
      enabled: newLinkDownRelay
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
	      {privateLine
	        ? 'Shut the LAN ports when the circuit (WAN0) is down.'
	        : 'Enable/Disable Link-Down Relay.'}
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <IOSSwitch color="primary" checked={newLinkDownRelay} onChange={handleChange} />
          }
          label={newLinkDownRelay ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !newLinkDownRelay ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
